import React from 'react';
import {
  Compass,
  PlusCircle,
  CheckSquare,
  Users,
  Package,
  Box,
  Lightbulb,
  UserCircle,
  Share2,
} from './icons';

export const WORKFLOW_NAV = [
  {
    id: "explore",
    label: "Explore",
    icon: <Compass size={20} />,
    active: true,
  },
  { id: "create", label: "Create", icon: <PlusCircle size={20} /> },
  { id: "review", label: "Review", icon: <CheckSquare size={20} /> },
  { id: "collaborate", label: "Collaborate", icon: <Users size={20} /> },
];

export const LIBRARIES_NAV = [
  { id: "products", label: "Products", icon: <Package size={20} /> },
  { id: "props", label: "Props", icon: <Box size={20} /> },
  { id: "inspiration", label: "Inspiration", icon: <Lightbulb size={20} /> },
];

export const PLATFORM_NAV = [
  { id: "users", label: "Users", icon: <UserCircle size={20} /> },
  { id: "integrations", label: "Integrations", icon: <Share2 size={20} /> },
];

export const DEFAULT_DIMENSIONS_BY_RATIO = {
  square: "2048x2048",
  portrait: "1600x2000",
  landscape: "2400x1350",
};

// Pixel dimensions for react-grid-gallery aspect ratio calculation
const GALLERY_DIMENSIONS = {
  square: { width: 1, height: 1 },
  portrait: { width: 4, height: 5 },
  landscape: { width: 16, height: 9 },
};

const RAW_ARTWORKS = [
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-8a07a066-9bc1-41c2-8819-07c817a0afc3/upscale_8985d6f8-0067-43ce-b7fc-76fca25e4875_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769532185085-2%2FCaptura%20de%20tela%202026-01-27%20134502.jpg",
    aspectRatio: "square",
    dimensions: "35H x 80.5W x 35.5D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-14add810-5a8c-451a-8a13-0e2d5079cf90/upscale_70152ecc-8a79-433d-8f9d-cc2ed3322327_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1765319849013-2%2Ftest_files_rc-upload-1763063868686-2_HomageCoffeeTable3QSSF22.jpg",
    aspectRatio: "landscape",
    dimensions: "16H x 44W x 44D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-1ce40b26-71e6-4119-81b0-55eeec1e0496/upscale_e853c6a6-7c8d-4194-bd40-f28cc2f02f5d_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769709648739-2%2Fdownload.jpeg",
    aspectRatio: "square",
    dimensions: "31H x 40W x 34D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-8cddaa6a-c6ca-40ba-9308-7b7d2ab889d0/upscale_3066cf5a-81d8-4d89-a8ba-42567d37ef81_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769640456638-2%2FTEXTURES%20BLOCKS%20ENTRANCE%20DOOR%20MAT.jpg",
    aspectRatio: "square",
    dimensions: "0.5H x 30W x 18D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-574673b1-ac15-405f-9fa1-276c09b0060b/upscale_f7269645-f1ea-4a04-8fc8-ba2acf077fc4_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769645025997-2%2FA633.png",
    aspectRatio: "square",
    dimensions: "38H x 71W x 28D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets-production/task-dbb7260e-1565-456f-b7b8-32254346cb12/upscale_d42f37ac-74d9-459a-ab64-b95aef88c1b9_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/uploads/f10db300-108a-4ffd-9fde-e9cc5609c87a_thumbnail.jpg",
    aspectRatio: "square",
    dimensions: "3.75 W x 5.7 H",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-33f33926-6fa0-46d4-a15c-e7974298c0fa/upscale_1b0a26ab-e947-401f-8dd4-63c3e5439304_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769711714156-5%2Fcoffeetable_square_grey.webp",
    aspectRatio: "square",
    dimensions: "12.5H x 45W x 45D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-289d0b9d-5666-4ea0-affa-0b60db9cabc4/upscale_2b295f5a-2eee-424e-a07e-c9428e0d7e3b_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769640169877-2%2F1968-Series-BelliniSnow.jpg",
    aspectRatio: "square",
    dimensions: "34H x 135W x 66D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-95037aee-8840-4fd1-af7f-8a33b834649c/upscale_f408a5cf-1857-4b1f-b7e0-28f527e0defe_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769642949577-2%2FTY5801_122K_S.jpg",
    aspectRatio: "square",
    dimensions: "30H x 80W x 42D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-ead51878-e91b-4fcf-8677-4a8cafb82608/upscale_953e4888-2cda-471f-badf-6bacafb1cba1_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769438982839-2%2FCaptura%20de%20tela%202026-01-26%20121405.jpg",
    aspectRatio: "square",
    dimensions: "37.5H x 29.5W x 43.5D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-9e778d7b-2ecc-4c2f-9dcf-bb169c2754b0/upscale_d2edb92c-e4cc-4cae-ba7c-a031ab1e64a4_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769441439531-2%2FCaptura%20de%20tela%202026-01-26%20123135.jpg",
    aspectRatio: "square",
    dimensions: "37.5H x 124W x 62D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-76d05acc-b933-47dd-aaf7-db63396bec2c/upscale_744700e8-c893-4dd4-85b7-94840e1d961d_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1768943246830-2%2FScreen%20Shot%202026-01-20%20at%201.06.54%20PM.png",
    aspectRatio: "square",
    dimensions: "22.62H x 54W x 5.5D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-cbd9508c-af69-44ab-b8af-b61e77dcdcab/upscale_9c6d51fc-60d0-41f5-8a7c-6b3ab3747ad3_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769704430533-2%2F3223-9049-83-silo.jpg",
    aspectRatio: "square",
    dimensions: "40.5H x 32W x 38D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-bfa4c8e2-c279-43fa-ac30-b9f0791bcc25/upscale_cb127681-26c4-480c-870c-981c7df7dd74_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769703828677-2%2F3221-9049-85-silo.jpg",
    aspectRatio: "square",
    dimensions: "40.5H x 38W x 38D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-acf28a3e-b10a-418c-abb8-d4f768c4b226/upscale_4a7795b4-c6cb-41b7-b626-7ec48fd04239_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769699534658-2%2F759-95-980007-48-silo.jpg",
    aspectRatio: "square",
    dimensions: "36H x 82W x 38D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-ef592113-f24c-499b-bee4-b3103fca9493/upscale_7f8e6a76-0cba-46be-92fb-4b6cbe745865_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1768902386894-2%2FCANNON-Front.jpg",
    aspectRatio: "square",
    dimensions: "20H x 60W x 20D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-082950c3-babf-4bde-9799-3740b43cf48e/upscale_aaa63b90-dd4f-4d94-8faa-5a2f2076b88a_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769523561562-2%2FDR-75660-OW_001.jpg",
    aspectRatio: "square",
    dimensions: "31.5H x 31.5W x 15.75D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-952a04d6-2e52-432d-879c-8919274d1bc5/upscale_d4e66fe0-3762-42ae-81b2-11a59b5f524f_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769542736983-2%2F2_bb5a00f1-80ce-4a80-8d3e-784c600ba05a.png",
    aspectRatio: "square",
    dimensions: "70H x 71W x 89D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-4d8d40e6-06af-4252-8a9a-c484137639b4/upscale_47895b36-eb4e-4b56-a136-573945809b5a_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769635826533-2%2F5521-06_a_8x8%20115%20DPI%20RGB%20.jpg",
    aspectRatio: "square",
    dimensions: "38H x 35W x 37D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-0b552852-5b5b-4e42-ba58-c24778217d9e/upscale_0a183710-4a3d-4e3d-a57a-7d16d25da222_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769637605418-2%2F7791-31_20260127_3%20(1).webp",
    aspectRatio: "square",
    dimensions: "37H x 85W x 42D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-87c2e764-71e9-4411-8b02-b7916cb2e57a/upscale_5f659d0d-ec60-4e45-b1c8-d4284fb15d15_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769621731536-2%2FXKGFLXE_KY260108.webp",
    aspectRatio: "square",
    dimensions: "34H x 94W x 44D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-0bf12120-7343-4974-8c7f-eca4801c2eac/upscale_2e7b1d03-810a-4b6c-a6d3-73a8d5286d41_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769027801477-2%2FScreenshot%202026-01-21%20at%202.41.16%E2%80%AFPM.png",
    aspectRatio: "square",
    dimensions: "34H x 95W x 81D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-4383251b-3f2a-443b-a54c-df738f606379/upscale_f6b9b5fa-13d3-404f-a65b-d9877e666810_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769577311847-2%2FVarick-Sofa_Performance-Velvet-Olive2_8d5ca463-f54f-4d95-8543-fa1619c15463.webp",
    aspectRatio: "landscape",
    dimensions: "30.5H x 90W x 40D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-0b9af959-9879-4688-81e4-4c549918d98c/upscale_91acfc82-fe4b-4ea7-a459-543451cb7fa9_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1765228810751-2%2FScreenshot%202025-12-08%20at%2011.24.48%E2%80%AFAM.png",
    aspectRatio: "portrait",
    dimensions: "32H x 34W x 32D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-5eee69a1-58a7-4852-a614-d6a6306f3a9e/upscale_d1db2d11-a414-4b53-99a6-179960e4a10a_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769465882374-2%2F5770-7900-TK.jpeg",
    aspectRatio: "square",
    dimensions: "31H x 67W x 68D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-705a4f74-0e25-4528-a35a-4a2e01199a4c/upscale_dcd4f65c-144f-4d8f-8cde-c5c99691e66f_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769472979313-5%2FBerlin%2BGardens%2BComfo%2BBack%2BFolding%2BAdirondack%2BChair-1708968499.jpeg",
    aspectRatio: "square",
    dimensions: "40H x 32W x 33D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-631af9d6-7e8a-46c0-a813-05c85e269a23/upscale_5abde934-4281-432c-bcee-0c97c24f9f35_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769631011187-2%2FSR-CT-43%2C%20Seashell%20%26%20Coastal%20with%20Seabreak%20chairs.png",
    aspectRatio: "square",
    dimensions: "42H x 50W x 50D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-b196d0e8-11ec-4083-b6e8-fb0c059393e6/upscale_87030190-77c1-48a6-af5e-802c36a36b2e_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769536640031-5%2FScreenshot%202026-01-27%20at%201.25.02%E2%80%AFPM.png",
    aspectRatio: "landscape",
    dimensions: "43H x 66W x 87D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-0bafec90-16a6-4a25-a766-a63b76885d34/upscale_f079de8a-8c96-439f-97ba-2fe16397ecd1_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769286418145-2%2FCaptura%20de%20tela%202026-01-24%20172904.jpg",
    aspectRatio: "square",
    dimensions: "7.99H x 2.95W x 2.95D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-24c27ce7-d908-4343-b9a5-6469d1ef6a06/upscale_fc15ecdf-9dc4-477c-837c-8e4f93a8bbe2_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769444047904-6%2FCaptura%20de%20tela%202026-01-26%20131537.jpg",
    aspectRatio: "square",
    dimensions: "31H x 29W x 28D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-3b9c2d0d-8431-41d2-9c15-95c99de6de07/upscale_0ca5df04-daa8-43f3-bfcf-7d0d6a909375_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769442189143-2%2FCaptura%20de%20tela%202026-01-26%20130144.jpg",
    aspectRatio: "landscape",
    dimensions: "30H x 72W x 42D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-24ff782b-dacc-49c8-ae4a-93814cab93c8/upscale_a3672087-7c90-4f46-b7a6-9b82403059e6_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769444783296-2%2F53130-296700.1.jpg",
    aspectRatio: "square",
    dimensions: "34H x 83W x 17D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-5a69d7c9-053b-437c-ad77-9a596d6e3ab9/upscale_b9dd20b9-70a9-42e0-b656-8002cf33a8a2_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769450899327-2%2FCaptura%20de%20tela%202026-01-26%20150801.jpg",
    aspectRatio: "square",
    dimensions: "40H x 22W x 29D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-e407ce60-d957-4cb2-a1e9-4e049bf79a16/upscale_e27c8125-ba12-4bcc-90d1-02c1b7436286_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769630485914-3%2FEmpress%20Counter%20Chairs%20with%20settee%20-%20Black%20%26%20Mahogany.jpg",
    aspectRatio: "square",
    dimensions: "51H x 68W x 33D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-5321f641-70dc-4375-9937-549e542298cf/upscale_007fe4e9-0d44-4cf4-abf9-25b0128deecc_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769552867725-2%2FCaptura%20de%20tela%202026-01-27%20192620.jpg",
    aspectRatio: "square",
    dimensions: "30H x 53W x 54D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-10c221e9-feb0-4f28-bb81-5d4bb3f9b609/upscale_04e7c373-f440-43c4-81e7-4e07127357ed_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769631663478-3%2F36%20Round%20Dining%20Table%20-%20Farmhouse%20Swivel%20Dining%20Chairs%20-%20patriot%20Blue%20%26%20Light%20Gray(2).png",
    aspectRatio: "square",
    dimensions: "38H x 55W x 55D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-3afe43a3-45cf-455f-87f3-c82a72da2c36/upscale_34fb1389-4c38-45a1-bbff-2a0d08560543_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769551868905-6%2F7200-100-TRACK.jpg",
    aspectRatio: "square",
    dimensions: "36H x 110W x 45D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-2129220f-c54e-4c77-8287-716003610569/upscale_9f9b0d62-33a7-4fbb-af1c-bf9dfc618a9a_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769486862219-2%2F6f58dd5ebcdda26c7e28a9d76aaff097_03a7ad2e-8755-4b09-ad18-5b3c17e23be9.webp",
    aspectRatio: "landscape",
    dimensions: "1H x 94W x 123D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-cf062eb8-9928-47c9-9d00-f3b9dcaa5df2/upscale_407f1f5b-9348-41d7-892f-43909a21225e_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769574034862-6%2F09-140_Cole_Dining_Table_WVSTAT7242_ANA_Champagne-1.jpg",
    aspectRatio: "square",
    dimensions: "30H x 72W x 42D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-6e8869b3-859b-4c12-8dd4-3700aec2a4a6/upscale_05fa452b-b23b-4f98-a71f-1ddf7dbf551f_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769572890250-2%2Fopal-63430-c-1.png",
    aspectRatio: "square",
    dimensions: "34H x 88W x 35D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-9abcd1af-a8ee-4879-820f-368319deade1/upscale_e61a46f5-6972-470d-a25b-c4b2c74a76be_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769573367859-6%2Fjaettebo-sectional-3-seat-samsala-dark-blue__1448011_pe989427_s5.jpeg",
    aspectRatio: "square",
    dimensions: "28H x 94.5W x 37D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-2b31a74f-d8e0-427f-b293-dada7d6ad776/upscale_6c9af97f-8cd7-4cda-ba14-5427cfc2b34c_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769550080562-2%2F5903-33_5903-32-Front.jpg",
    aspectRatio: "square",
    dimensions: "36H x 102W x 91D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-6136155c-c09a-4013-9241-6afecdc5ea8e/upscale_b2d55502-027c-48ae-8565-4b3cbbbd0a42_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769447094363-6%2FNS-68775-OW_001.jpg",
    aspectRatio: "square",
    dimensions: "26H x 28W x 15D",
  },
  {
    url: "https://d48f7equ64qjl.cloudfront.net/lifestyle-product_assets/task-9d70c9e6-86e0-497a-bf3e-247de490de13/upscale_35091ceb-543c-4d23-9792-611531e6a625_thumbnail.jpg",
    hoverUrl:
      "https://d48f7equ64qjl.cloudfront.net/test_files%2Frc-upload-1769447554334-2%2FDR-68848-OW_001.jpg",
    aspectRatio: "square",
    dimensions: "32.5H x 34W x 18D",
  },
];

export const buildArtworks = (rawArtworks, idPrefix = "artwork") =>
  rawArtworks.map((artwork, index) => {
    const resolvedAspectRatio = artwork.aspectRatio || "square";
    const galDims = GALLERY_DIMENSIONS[resolvedAspectRatio] || GALLERY_DIMENSIONS.square;
    return {
      id: artwork.id || `${idPrefix}-${index + 1}`,
      src: artwork.url,
      url: artwork.url,
      hoverUrl: artwork.hoverUrl,
      aspectRatio: resolvedAspectRatio,
      width: galDims.width,
      height: galDims.height,
      dimensions:
        artwork.dimensions || DEFAULT_DIMENSIONS_BY_RATIO[resolvedAspectRatio],
    };
  });

export const MOCK_ARTWORKS = buildArtworks(RAW_ARTWORKS);
